export default __webpack_public_path__ + "static/media/6m-min.de038da8.jpg";